<script>
  import {data, cat} from './datafile'
  import Legend from './Legend.svelte'

  let ethnicity = [
    "Living alone",
    "Living in a couple"
    ],
    sex = ['Female', 'Male'],
    status = [
      "Very good or good health",
      "Fair health",
      "Bad or very bad health"
    ],
    age = ['65-69', '70-74', '75-79', '80-84', '85-89', '90+'].reverse()
</script>

<style>
  .sex {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
  }
  .spacer {
    height: 20px;
  }
  .age {
    display: inline-block;
    width: 120%;
    margin: 2px;
    background-color: #ececec94;
  }

  .green {
    background-color: #6749a6;
    width: 100%;
    height: 100%;
    float: right;
  }

  .male {
  }

  .female {
    flex-direction: row-reverse;
  }

  .blue {
    background-color: #2ea1a4;
    width: 100%;
    height: 100%;
  }

  .filler {
    min-width: 5px;
    min-height: 8px;
  }

  .label {
    text-align: right;
    font-weight: 500;
    font-size: 12px;
  }
  table {
    table-layout: fixed;
    width: 100%;
    max-width: 800px;
  }
  td {
    width: 15%;
    vertical-align: middle;
  }
  th,
  td {
    font-size: 12px;
    font-weight: 500;
    vertical-align: bottom;
  }
  .legendPic{
    float:right;
    margin-bottom:15px
  }
  .outer{
    max-width:800px
  }
  #source {
      font-size: 16px;
      font-weight: 400;
      line-height: 18px;
      margin: 16px 0 8px 0;
      color:#707071
    }
    .agelabel{
  width:fit-content;
  text-align: right;
  font-size: 10px;
  vertical-align: middle;
}
.visuallyhidden{
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
 	clip: rect(0,0,0,0);
	border: 0;
}

</style>
<h5 id="accessibleSummary" class="visuallyhidden"> Bar chart showing that women in age groups from 65 to 79 years and men in age groups from 65 to 84 years living on their own were more likely to be in very bad or bad health than those living with other people. It also shows that people aged 65 to 89 years living as a couple are more likely to be in very good or good health than those not living as a couple, regardless of whether those not living as a couple live with other people.</h5>
<div class="outer" aria-hidden="true" >


<table>
  <tr class="bucket">
    <td class="status"></td>
    {#each status as stat, ii}
    <td class="status">{#if ii==0}<Legend/>{/if}</td>
    {/each}
  </tr>
</table>

<table>
  <th class="status" />
  {#each status as stat, ii}
    <th class="status">{stat}</th>
  {/each}
  {#each ethnicity as ethnic, i}
    <tr class="bucket">

            <td class="agelabel">
        {#each age as age, x}
            <div class="agelabelDiv">{#if x==0}<span style="float:left; font-size:12px; margin-top:-12px">{ethnic}</span>{/if}<span>{age}</span></div>
        {/each}
      </td>
      <!-- {ethnic}
      <br />-->
      {#each status as stat, ii}
        <td class="status">
          <!--{stat}<br>-->
          {#each age as age, iii}
            <div class="sex">
              <!--{sex}<br>-->
              {#each sex as sex, iiii}


                {#if sex == 'Female'}
                  <div class="age female">
                    <div
                      class="green"
                      style="width:{data.find((e) => e.age == age && e.category == ethnic && e.sex == sex && e.type == stat)['value']*100 || 0}%">
                      <div class="filler" />
                    </div>
                  </div>
                {/if}


                {#if sex == 'Male'}
                  <div class="age male">
                    <div
                      class="blue"
                      style="width:{data.find((e) => e.age == age && e.category == ethnic && e.sex == sex && e.type == stat)['value']*100 || 0}%">
                      <div class="filler" />
                    </div>
                  </div>
                {/if}

                
              {/each}
            </div>
          {/each}
        </td>
      {/each}
    </tr>
    <tr class="spacer" />
  {/each}
</table>
</div>
<div class="row" id="source">Source: Census 2021 from the Office for National Statistics</div>